var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResizeFullIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5334 15.5333H2.46676V2.46664H7.13343V0.599976H2.46676C1.97169 0.599976 1.4969 0.796642 1.14683 1.14671C0.796764 1.49678 0.600098 1.97157 0.600098 2.46664V15.5333C0.600098 16.0284 0.796764 16.5032 1.14683 16.8532C1.4969 17.2033 1.97169 17.4 2.46676 17.4H15.5334C16.0285 17.4 16.5033 17.2033 16.8534 16.8532C17.2034 16.5032 17.4001 16.0284 17.4001 15.5333V10.8666H15.5334V15.5333Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5076 0.599976L13.3507 3.44305L8.43994 8.35382L9.6461 9.55997L14.5569 4.64921L17.3999 7.49228V0.599976H10.5076Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeFullIcon);
export default __webpack_public_path__ + "static/media/resize-full-icon.e6706fc99965a9e5de9aad9aa11a127e.svg";
export { ForwardRef as ReactComponent };